import React from 'react'

function ArrowPrice() {
  return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9279 1.55132L5.03998 10.4486L1 6.40441" fill="white"/>
        <path d="M13.9279 1.55132L5.03998 10.4486L1 6.40441" stroke="#3B71FE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  )
}

export default ArrowPrice;